import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "買取の流れ", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = [
  {
    heading: 'お見積りのご依頼',
    description:
      'まずは査定お見積りのご依頼を。<br>折り返しご連絡いたします。<br>その上でお手続きを進めるかご判断ください。',
  },
  {
    heading: '必要書類の準備',
    description:
      '引き取りにあたりお客様にご準備いただく書類がありますので、必要書類をご確認の上、準備をお願いいたします。',
  },
  {
    heading: '車の引き取り',
    description:
      'ご指定の保管場所（駐車場）まで、<br>専用の積載車にて引き取りにお伺いします。<br>お客様の御ご都合でお持ち込み頂くことも可能です。<br>最寄りの駅までお送りさせて頂きます。',
  },
  {
    heading: '買取金額のお支払',
    description: '買い取り代金をお振込みします。<br>陸運局での書類手続きを行い、完了通知を郵送いたします。',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, _hoisted_2, 2),
    _createElementVNode("ol", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(data, ({ heading, description }, i) => {
        return _createElementVNode("li", {
          key: `flow${i + 1}`,
          class: _normalizeClass(_ctx.$style.item)
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.step)
          }, [
            _createElementVNode("img", {
              src: `/estimate/img/step0${i + 1}.png`,
              alt: `STEP${i + 1}`
            }, null, 8, _hoisted_3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.itemHeading)
          }, _toDisplayString(heading), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.description),
            innerHTML: description
          }, null, 10, _hoisted_4)
        ], 2)
      }), 64))
    ], 2)
  ]))
}
}

})